<script setup>
    import { TagIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <TagIcon />
</template>
